import React from "react";
import { useModal } from "../context/ModalContext";

import Header from "../components/Header";
import Footer from "../components/Footer";
import GlobalCta from "../components/global/GlobalCta";
import PageHero from "../components/global/PageHero";
import ContactInfo from "../components/contact/ContactInfo";
import ContactForm from "../components/contact/ContactForm";

export default function Contact() {
    const { openModal } = useModal();

    return (
        <>
            <Header />

            <main>
                <PageHero eyebrow="Contact" title="Let's build something that fits.">
                    Prefer a guided brief?{" "}
                    <button className="linklike" onClick={openModal} type="button">Start a project →</button>
                </PageHero>

                <section className="container sec-contact">
                    <div className="contact-split">
                        <ContactInfo />
                        <ContactForm />
                    </div>
                </section>
            </main>

            <GlobalCta />

            <Footer />
        </>
    );
}
